import { create } from 'zustand';

type LassoToolState = {
    isEnabled: boolean;
    toggle: () => void;
    clear: () => void;

    /*
    selection: [
      { type: 'Feature', geometry: { type: 'Polygon', coordinates: [...] }, properties: {} },
      { type: 'Feature', geometry: { type: 'Polygon', coordinates: [...] }, properties: {} }
    ]
    */
    selection: GeoJSON.Feature[];
    setSelection: (update: GeoJSON.Feature[] | ((prev: GeoJSON.Feature[]) => GeoJSON.Feature[])) => void;

    draw: MapboxDraw | null;
    setDraw: (draw: MapboxDraw | null) => void;
  }
export const useLassoTool = create<LassoToolState>((set) => ({
  isEnabled: false,
  toggle: () => set((state) => ({ isEnabled: !state.isEnabled })),
  clear: () => set({ selection: [] }),

  selection: [],
  setSelection: (update: GeoJSON.Feature[] | ((prev: GeoJSON.Feature[]) => GeoJSON.Feature[])) => set((state) => ({ selection: typeof update === 'function' ? update(state.selection) : update })),

  draw: null,
  setDraw: (draw) => set({ draw })
}));
